import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import { dateService } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';

export class DapSpreadsheetAprovationFlow extends Spreadsheet {
  mount(dataSource: any[]) {
    this.name = 'Estrategia_Local_Fluxo_Aprovacao';
    const totalMonths = dataSource[0].forecast_RapFamilyResultsPerMonth.length;
    const totalConsolidado = dataSource[0].consolidate.length;
    const totalMonthHierarchy = [
      ..._(dataSource[0].forecast_RapFamilyResultsPerMonth)
        .groupBy((d: any) => d.approvalHierarchy)
        .map((d: any) => [...d])
        .value()
    ][0].length;

    const initialValue = 10;

    const forescast = _(dataSource[0].forecast_RapFamilyResultsPerMonth)
      .groupBy((d: any) => d.approvalHierarchy)
      .map((d: any) => [...d])
      .value();

    const idsHierarchy = _(forescast)
      .map((d: any, i: number) => d[0].approvalHierarchy)
      .value();

    const title =
      'TOYOTA VENDA DIRETA - ESTRATÉGIA LOCAL - FLUXO APROVAÇÃO ' +
      dataSource[0].forecast_RapFamilyResultsPerMonth[0].year;

    const sections: Array<any> = [
      { key: 'main', text: title, index: 0 },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          text: '',
          index: initialValue + totalConsolidado + (i == 0 ? 0 : i * totalMonthHierarchy)
        }))
        .value()
    ];

    if (totalConsolidado > 0) {
      sections.push({ key: 'consolidate', text: '', index: initialValue });
    }

    const sectionColumns: any = [
      {
        key: 'main',
        source: [
          { key: 'dealerNumber', text: 'DN' },
          { key: 'dealerName', text: 'NOME' },
          { key: 'groupName', text: 'GROUP' },
          { key: 'markedAreaName', text: 'ÁREA DEMARCADA' },
          { key: 'region', text: 'REGIÃO' },
          { key: 'aov', text: 'AOV' },
          { key: 'regionale', text: 'REGIONAL' },
          { key: 'familyName', text: 'FAMÍLIA' },
          { key: 'nameAggregate', text: 'CANAL' },
          { key: 'dealerCompleted', text: 'DEALER FINALIZADO' }
        ]
      },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          source: _(d)
            .map((d: any) => ({
              key: 'value',
              text: d.monthName.toUpperCase().slice(0, 3) + ' ' + d.year.toString().slice(2, 4) + '\'',
              format: '#,0'
            }))
            .value()
        }))
        .value()
    ];

    if (totalConsolidado > 0) {
      sectionColumns.push({
        key: 'consolidate',
        source: [
          ..._(dataSource[0].consolidate)
            .map((d: any) => ({
              key: 'value',
              text: d.description
            }))
            .value()
        ]
      });
    }

    const sectionColumnsDescription: any = [
      {
        key: 'main',
        source: [{ key: 'main', text: 'DATA: ' + moment(new Date()).format('DD/MM/YYYY hh:mm') }]
      },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          source: _(d)
            .map((d: any) => ({
              key: 'approvalHierarchy',
              text: d.approvalHierarchyName
            }))
            .uniqBy((d: any) => d.text)
            .value(),
          index: initialValue + totalConsolidado + (i == 0 ? 0 : i * totalMonthHierarchy)
        }))
        .value()
    ];

    if (totalConsolidado > 0) {
      sectionColumnsDescription.push({
        key: 'consolidate',
        source: [{ key: 'consolidate', text: 'RESULTADO' }]
      });
    }

    const baseStyle: any = {
      color: '#212121',
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      main: '#bdbdbd',
      consolidate: '#90a4ae',

      '0': '#e57373',
      '1': '#ffb74d',
      '3': '#e57373'
    };

    const baseBorderColorStyle: any = {
      main: '#e0e0e0',
      consolidate: '#cfd8dc',

      '0': '#ffcdd2',
      '1': '#ffe0b2',
      '3': '#ffcdd2'
    };

    const baseBackgroundColorStyle: any = {
      main: '#fafafa',
      consolidate: '#f9fafb',

      '0': '#fff5f6',
      '1': '#fffbf5',
      '3': '#fff5f6'
    };

    const headerStyle = _.reduce(
      baseColorStyle,
      (acc: any, val: string, key: string) => {
        acc[key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[key] });
        return acc;
      },
      {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    this.workbookOptions = {
      sheets: _.map(
        [dataSource],
        (data: any, name: string) =>
          ({
            name: 'Estrategia_LocalFluxo_Aprovação',
            frozenColumns: 2,
            frozenRows: 3,
            filter: {
              ref: `A3:${this.columnIndex[initialValue + totalMonths + totalConsolidado - 1]}${data.length + 3}`,
              columns: []
            },
            rows: [
              {
                height: 30,
                cells: [
                  ..._.map(sections, (section: any) =>
                    _.assign({}, headerStyle[section.key], {
                      value: section.text,
                      index: section.index,
                      borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderRight: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderTop: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderBottom: { color: baseBorderColorStyle[section.key], size: 1 }
                    })
                  )
                ]
              },
              {
                height: 30,
                cells: [
                  ..._(sectionColumnsDescription)
                    .map((columns: any, key: any) =>
                      _.map(columns.source, (cell: any) =>
                        _.assign({}, getCellStyle(cell.color || columns.key), {
                          value: cell.text,
                          bold: true,
                          textAlign: cell.key === 'main' ? 'left' : 'center',
                          borderLeft: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[columns.key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              {
                height: 30,
                cells: [
                  ..._(sectionColumns)
                    .map((columns: any, key: any) =>
                      _.map(columns.source, (cell: any) =>
                        _.assign({}, headerStyle[cell.color || columns.key], {
                          value: cell.text,
                          wrap: true,
                          borderLeft: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[columns.key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              ..._.map(data, d => {
                return {
                  cells: [
                    ..._(sectionColumns)
                      .map((columns: any, key: any) =>
                        _.map(columns.source, (cell: any, index: number) => {
                          if (columns.key === 'consolidate') {
                            if (
                              !d ||
                              !d[columns.key] ||
                              !d[columns.key][index] ||
                              (!d[columns.key][index][cell.key] && d[columns.key][index][cell.key] != 0)
                            ) {
                              return _.assign({}, getCellStyle(cell.color || columns.key), {
                                value: 0,
                                format: cell.format
                              });
                            }
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d[columns.key][index][cell.key],
                              format: cell.format
                            });
                          }

                          if (idsHierarchy.some(s => s == columns.key)) {
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d.forecast_RapFamilyResultsPerMonth.filter(function(f) {
                                return f.approvalHierarchy == columns.key;
                              })[index][cell.key],
                              format: cell.format
                            });
                          }

                          return _.assign({}, getCellStyle(cell.color || columns.key), {
                            value: d[cell.key],
                            format: cell.format,
                            textAlign: cell.textAlign || 'center'
                          });
                        })
                      )
                      .flatten()
                      .value()
                  ]
                };
              })
            ],
            columns: [
              {
                index: 0,
                width: 100
              },
              {
                index: 1,
                width: 150
              },
              {
                index: 2,
                width: 100
              },
              {
                index: 3,
                width: 150
              },
              {
                index: 4,
                width: 100
              },
              {
                index: 5,
                width: 80
              },
              {
                index: 6,
                width: 100
              },
              {
                index: 7,
                width: 150
              },
              {
                index: 8,
                width: 150
              },
              {
                index: 9,
                width: 150
              },
              ..._.map(_.range(0, dataSource.length - 7), index => ({
                index: index + 7,
                width: 80
              }))
            ],
            showGridLines: false,
            mergedCells: [
              `A1:${this.columnIndex[initialValue + totalConsolidado + totalMonths - 1]}1`,
              `A2:${this.columnIndex[initialValue - 1]}2`,
              totalConsolidado
                ? `${this.columnIndex[initialValue + 1 - 1]}2:${this.columnIndex[initialValue + totalConsolidado - 1]}2`
                : '',
              ..._.map(
                _.filter(sectionColumnsDescription, (d: any) => d.key != 'consolidate' && d.key != 'main'),
                (c: any) => `${this.columnIndex[c.index]}2:${this.columnIndex[c.index + totalMonthHierarchy - 1]}2`
              )
            ].filter(function(f) {
              return f != '';
            })
          } as any)
      )
    };

    return this;
  }
}
